import { Injectable } from '@angular/core';
import { PopUpService } from '../componentes/pop-up/pop-up.service';
import { OwsClientService } from 'ows-library';
import { Subject } from 'rxjs';
import { OwsServiceErrorResponse } from 'ows-library/src/ows-service-error-response';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import {AuthorizationServicesEnum, OwsJSON} from 'ows-library';

@Injectable()
export class RequestsService {
  anexoDocumentoChanged = new Subject<any>();
  listaPermissoes = [];

  /*  Constrói a tela, instaciando todos os serviços a serem utilizados pela mesma
    Se necessário, checa as permissoes de usuário para permitir quais operações de Crud poderão ser executadas */
  constructor(private http: HttpClient,
    private router: Router,
    private popUpService: PopUpService,
    private owsClientService: OwsClientService) {
  }

  getPermissoesIniciais(path: string) {
    for (let i = 0; i < this.listaPermissoes.length; i++) {
      if (this.listaPermissoes[i].path === path) {
        return this.listaPermissoes[i];
      }
    }
  }

  visualizarDocumentoPDF(documentoPdf: any) {
    this.owsClientService.post<any>('relatorios/pdf', documentoPdf, {
      authorizationService: AuthorizationServicesEnum.None,
    }).subscribe((response) => {
      this.anexoDocumentoChanged.next(response.body.url);
    },
      error => {
        if (error instanceof Error) {
          this.popUpService.showCustomPopWarning('Erro de conexão', error.message);
        } else {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', (<OwsServiceErrorResponse>error).error.Code + ': ' + (<OwsServiceErrorResponse>error).error.Message);
        }
      });
  }
}